import { useState, Suspense } from 'react';
// @ts-ignore type check failes on this for some reason
import Button from '@atlaskit/button/new';
import { Popup } from '@atlaskit/popup';
import { useQueryLoader } from 'react-relay';
import GET_POST_SUMMARIZER_QUERY, {
  GetPostSummarizerQuery,
} from 'graphql/__generated__/GetPostSummarizerQuery.graphql';
import { SummarizedResults } from './SummarizedResults';
import { SkeletonLoader } from './SkeletonLoader';

interface Props {
  postId: string;
}

export const SummarizePost = ({ postId }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [queryRef, loadQuery, disposeQuery] = useQueryLoader<GetPostSummarizerQuery>(GET_POST_SUMMARIZER_QUERY);

  const onClose = () => {
    setIsOpen(false);
    disposeQuery();
  };

  const handleSummarizeClick = () => {
    setIsOpen(true);
    loadQuery({ postId });
  };

  const renderContent = () => {
    if (!queryRef) return null;

    return (
      <Suspense fallback={<SkeletonLoader />}>
        <SummarizedResults queryRef={queryRef} onClose={() => setIsOpen(false)} />
      </Suspense>
    );
  };

  return (
    <Popup
      shouldRenderToParent
      isOpen={isOpen}
      onClose={onClose}
      placement="bottom-end"
      content={renderContent}
      trigger={(triggerProps) => (
        <Button
          {...triggerProps}
          appearance="discovery"
          isSelected={isOpen}
          isDisabled={isOpen}
          onClick={handleSummarizeClick}
          isLoading={isOpen && !queryRef}
          spacing="compact"
        >
          ✨
        </Button>
      )}
    />
  );
};
